import { EMPTY_ARRAY } from '@e-socna/empty';

import type { MissionWarningsContextData } from '../types/warning.type';

export const EMPTY_CONTEXT_DATA: MissionWarningsContextData = {
  warnings: EMPTY_ARRAY,
  isGisUnavailable: false,
};
